<template>
  <nav class="pagination">
    <router-link v-if='currentPage - 1 > 0' :to='addToQuery({ page: currentPage - 1 })' aria-label="Previous page" class="back-controls">
      <i class="fas fa-chevron-left"></i>
      <span>{{ $t('pagination.prev') }}</span>
    </router-link>

    <a href="#" class="active disabled" v-if='pages.length === 1'>
      {{ $t('pagination.page') }}
    </a>

    <ul v-else-if='currentPage > 0'>
      <li v-for='page in pages' :key='page'>
        <router-link :to='addToQuery({ page: page })' :class='{ active: currentPage == page }'>
          {{ page }}
        </router-link>
      </li>
    </ul>

    <router-link v-if='currentPage + 1 <= lastPage' :to='addToQuery({ page: currentPage + 1 })' aria-label="Next page" class="forward-controls">
      <span>{{ $t('pagination.next') }}</span>
      <i class="fas fa-chevron-right"></i>
    </router-link>

    <select @change='updateDefaults($event)' :value='offset'>
      <option value='100' selected>{{ $t('pagination.per_page_100') }}</option>
      <option value='50'>{{ $t('pagination.per_page_50') }}</option>
      <option value='25'>{{ $t('pagination.per_page_25') }}</option>
    </select>
  </nav>
</template>

<script>
  export default {
    computed: {
      total() {
        return this.meta.total
      },
      currentPage() {
        return this.meta.page
      },
      offset() {
        return this.currentUser.defaults ? this.currentUser.defaults.offset : this.meta.offset
      },
      lastPage() {
        if (!this.total || !this.offset)
          return 0

        return Math.ceil(this.total / this.offset)
      },
      pages() {
        const lower = Math.max(1, this.currentPage - 4)
        const upper = Math.min(this.lastPage, lower + 8)

        const pages = []
        for(let i = lower; i <= upper; ++i)
          pages.push(i)

        return pages
      },
    },
    methods: {
      updateDefaults(e) {
        const newDefaults = Object.assign({}, this.currentUser.defaults, { offset: parseInt(e.target.value) })

        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
          this.store.getCurrentUser().then(() => {
            const q = Object.assign({}, this.$route.query)
            delete q.page
            this.$router.replace({ query: q })
          })
        })
      },
    },
  }
</script>
